export const CDN_URL = "https://np-cdn.strikie.com";
export const FLAG_CDN_URL = "https://flagcdn.com/w320";
export const API_BASE_URL =
  process.env.REACT_APP_API_URI || "https://dev-core-api.strikie.com";

export const EARLY_ACCESS_SECURE_KEY = "@!@345STrIkIe254^7!";
